// extracted by mini-css-extract-plugin
module.exports = {"inputs":"Inputs_inputs__IMS6h","item":"Inputs_item__1nurG","nameInput":"Inputs_nameInput__2JJKj","type":"Inputs_type__1NHsU","delete":"Inputs_delete__3dEa9"};